import React from 'react';
import DashboardFrame from '../components/basic/DashboardFrame';
import strings from '../values/strings/strings';

function System(props) {
    return (
        <DashboardFrame title={strings.getString('screen_system_title')}>
        </DashboardFrame>
    );
}

export default System;